export const userHasRole = (user: any, role: string) => {
    for (let userRole of user.roles) {
        if (userRole.name === role) {
            return true;
        }
    }
    return false;
};



// WEBPACK FOOTER //
// ./src/utils/userUtils.tsx